import { useEffect, useState } from 'react';
import type { TeamLiveData } from '../types';
import { fetchAllTeamData, computePowerRankings } from '../lib/espnApi';

export function useTeamLiveData() {
  const [data, setData] = useState<Record<string, TeamLiveData>>({});
  const [rankings, setRankings] = useState<Record<string, number>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const all = await fetchAllTeamData();
      if (cancelled) return;
      setData(all);
      setRankings(computePowerRankings(all));
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  return { data, rankings, loading };
}
